import styled from 'react-emotion'

const WhiteCard = styled.div`
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #cccccc;
`

export default WhiteCard
